import { SPEND_TYPES } from '../../shared/AppConstants';
import { fetchWithAuth } from '../../shared/fetch-json.util';
import { getEnvVar } from '../../utils/getEnvVar';

function prepareJSON(strategySpend, spendType) {
  let growAmt = strategySpend.growSpend;
  let maintainAmt = strategySpend.maintainSpend;
  let controlAmt = strategySpend.controlSpend;
  let reduceAmount = strategySpend.reduceSpend;
  let donotuseAmount = strategySpend.doNotUseSpend;
  let limitedUseAmount = strategySpend.limitedUseSpend;

  let values = {
    grow: growAmt,
    maintain: maintainAmt,
    control: controlAmt,
    reduce: reduceAmount,
    donotuse: donotuseAmount,
    limiteduse: limitedUseAmount
  };

  let numerator = growAmt + maintainAmt + controlAmt;
  let denominator =
    parseInt(numerator) + parseInt(reduceAmount) + parseInt(donotuseAmount);
  let percentage = Math.round((numerator / denominator) * 100);

  return {
    values: values,
    numerator: numerator,
    denominator: denominator,
    percentage: percentage,
    spendType: spendType
  };
}

function getChartObject(spendInfo) {
  return {
    'this strategy': spendInfo?.totalSpend ? spendInfo.totalSpend : 0,
    'other strategy': spendInfo?.outOfScopeTotalSpend
      ? spendInfo.outOfScopeTotalSpend
      : 0
  };
}

export function prepareStrategySpendData(
  invoiceSpend,
  forecastSpend,
  setSpendGraphData
) {
  let data = [];

  if (invoiceSpend) data.push(prepareJSON(invoiceSpend, SPEND_TYPES.INVOICED));
  if (forecastSpend)
    data.push(prepareJSON(forecastSpend, SPEND_TYPES.FORECAST));

  setSpendGraphData(data);
}

export function prepareAllMGCSpendData(strategyInformation, setAllMGCSpend) {
  let data = [];
  let invoiceSpend = {
    values: getChartObject(strategyInformation.invoiceSpend),
    spendType: SPEND_TYPES.INVOICED
  };

  data.push(invoiceSpend);

  let forecastSpend = {
    values: getChartObject(strategyInformation.forecastSpend),
    spendType: SPEND_TYPES.FORECAST
  };

  data.push(forecastSpend);
  setAllMGCSpend(data);
}

export const getSepSpendGraphData = async (
  initialSpendGraphData,
  strategyNumber
) => {
  const url = `${getEnvVar('VITE_DMSM_API_URL')}/strategies/${strategyNumber}/sep-forecast-spend`;
  const updatedSpendData = [...initialSpendGraphData];

  const rawResponse = await fetchWithAuth(url);
  const sepData = await rawResponse.json();

  // Extract parts data if present
  const partsData = sepData.parts || [];

  const sortedKeys = Object.keys(sepData)
    .filter((key) => key !== 'parts') // Exclude 'parts' key from year processing
    .sort((a, b) => Number(a) - Number(b));

  for (const key of sortedKeys) {
    const newYearSepData = sepData[key];
    const previousYearSpendData = updatedSpendData[updatedSpendData.length - 1];

    const newYearDenominator =
      previousYearSpendData.denominator +
      newYearSepData.controlDelta +
      newYearSepData.doNotUseDelta +
      newYearSepData.growDelta +
      newYearSepData.limitedUseDelta +
      newYearSepData.maintainDelta +
      newYearSepData.reduceDelta;
    const newYearNumerator =
      previousYearSpendData.numerator +
      newYearSepData.controlDelta +
      newYearSepData.growDelta +
      newYearSepData.maintainDelta;

    const newYearData = {
      denominator: newYearDenominator,
      numerator: newYearNumerator,
      percentage: newYearDenominator
        ? newYearNumerator / newYearDenominator
        : 0,
      spendType: `FY${key}`,
      values: {
        grow: previousYearSpendData.values.grow + newYearSepData.growDelta,
        maintain:
          previousYearSpendData.values.maintain + newYearSepData.maintainDelta,
        control:
          previousYearSpendData.values.control + newYearSepData.controlDelta,
        reduce:
          previousYearSpendData.values.reduce + newYearSepData.reduceDelta,
        donotuse:
          previousYearSpendData.values.donotuse + newYearSepData.doNotUseDelta,
        limiteduse:
          previousYearSpendData.values.limiteduse +
          newYearSepData.limitedUseDelta
      }
    };

    updatedSpendData.push(newYearData);
  }

  return { spendData: updatedSpendData, parts: partsData };
};
